import { render, staticRenderFns } from "./BooleanStatus.vue?vue&type=template&id=48621804&"
import script from "./BooleanStatus.vue?vue&type=script&lang=js&"
export * from "./BooleanStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports